import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { TitanRelatedReports } from '@cyborg-monorepo/hunter/common';

@Injectable({
  providedIn: 'root',
})
export class TitanService {
  constructor(private httpClient: HttpClient) {}

  private apiUrl: string = environment.api + '/v2';

  public getRelatedTitanReports(uuid: string): Observable<TitanRelatedReports> {
    return this.httpClient.get<TitanRelatedReports>(
      `${this.apiUrl}/titan/threat-profile-reports/${uuid}`,
    );
  }
}
